import TranslationText from '@Components/Utilities/TranslationText';

const ErrorNavigationButtons = (props) => {
    return (
        <div className='center'>
            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); window.history.go(-1); } }} onClick={() => window.history.go(-1)} className='not-found-btn'><i className='fas fa-backward' /><br /> <TranslationText tKey='previouspagebutton' /></a>
            <a href={props.HomeURL} className='not-found-btn'><i className='fas fa-home' /><br /> <TranslationText tKey='sandhills.tradepubwebsite.mvc.errorpageparagraphfour' /></a>
            {props.ContactUsURL && <a href={props.ContactUsURL} className='not-found-btn'><i className='fas fa-phone' /><br /><TranslationText tKey='sandhills.tradepubwebsite.mvc.contactus' /></a>}
        </div>
    );
};

export default ErrorNavigationButtons;